import React, { useEffect, useState, useContext } from 'react';

import Slider from '../components/Slider.jsx'
import CategoriaLista from '../components/CategoriaLista.jsx'

import { validarME } from '../api/apiMe'
import { MeuContexto } from "../App"
import CompActive from '../components/CompActive.jsx';

function PgHome() {
  const [isloading, setisloading] = useState(true);
  const { setlogado, setusername, setuser } = useContext(MeuContexto)

  useEffect(() => {
    _carregatela()
  }, [])

  async function _carregatela() {
    const me = await validarME.me()
    if (me) {
      setuser(me)
      setusername(me.username)
      setlogado(true)
    } else {
      setuser([])
      setlogado(false)
    }
    setisloading(false)
  }

  return (
    <main 
      className="min-h-screen bg-background font-nunito text-text antialiased relative overflow-x-hidden"
      role="main"
      aria-label="SMIZE Home Page"
    >
      {/* Decorative background element for atmosphere */}
      <div className="absolute top-0 left-0 w-full h-[60vh] bg-gradient-to-br from-primary/10 via-background to-background -z-0" />

      {/* Hero Section Container */}
      <section 
        className="relative z-10"
        aria-label="Featured Content"
      >
        <Slider />
      </section>

      {/* Content Categories Section */}
      <section 
        className="relative z-10 bg-background py-8"
        aria-label="Content Categories"
      >
        {isloading ? (
          <div className="flex flex-col items-center justify-center h-64">
            <CompActive size="lg" text="Loading awesome content..." />
          </div>
        ) : (
          <div className="space-y-12 px-4 md:px-8 lg:px-12">
            <CategoriaLista />
          </div>
        )}
      </section>
    </main>
  )
}

export default PgHome
